import React from 'react';

import SvgIcon from '@mui/material/SvgIcon';

export const CustomAmericanFlag = (props: {}): JSX.Element => (
    <SvgIcon {...props} viewBox={'0 0 30 20'}>
        <svg width={'30'} height={'20'} viewBox={'0 0 30 20'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'}>
            <rect width={'30'} height={'20'} fill={'white'} />
            <path fillRule={'evenodd'} clipRule={'evenodd'} d={'M0 0V1.53846H30V0H0Z'} fill={'#D91667'} />
            <path fillRule={'evenodd'} clipRule={'evenodd'} d={'M0 3.07678V4.61524H30V3.07678H0Z'} fill={'#D91667'} />
            <path fillRule={'evenodd'} clipRule={'evenodd'} d={'M0 6.15387V7.69233H30V6.15387H0Z'} fill={'#D91667'} />
            <path fillRule={'evenodd'} clipRule={'evenodd'} d={'M0 9.23065V10.7691H30V9.23065H0Z'} fill={'#D91667'} />
            <path fillRule={'evenodd'} clipRule={'evenodd'} d={'M0 12.3077V13.8462H30V12.3077H0Z'} fill={'#D91667'} />
            <path fillRule={'evenodd'} clipRule={'evenodd'} d={'M0 15.3848V16.9233H30V15.3848H0Z'} fill={'#D91667'} />
            <path fillRule={'evenodd'} clipRule={'evenodd'} d={'M0 18.4616V20.0001H30V18.4616H0Z'} fill={'#D91667'} />
            <rect width={'15'} height={'10.7692'} fill={'#265CFF'} />
            <rect width={'15'} height={'10.7692'} fill={'black'} fillOpacity={'0.4'} />
        </svg>
    </SvgIcon>
);
